export const bankList = ['安徽省农村信用社联合社',
  '鞍山银行',
  '奥地利中央合作银行',
  '澳大利亚西太平洋银行有限公司',
  '澳门地区的银行',
  '澳新银行',
  '巴伐利亚洲银行',
  '巴中农村商业银行',
  '百色右江华润村镇银行',
  '包商银行',
  '保定银行',
  '北川羌族自治县富民村镇银行',
  '北京昌平包商村镇银行营业部 ',
  '北京大兴华夏村镇银行',
  '北京大兴九银村镇银行',
  '北京房山沪农商村镇银行',
  '北京怀柔融兴村镇银行有限责任公司',
  '北京门头沟珠江村镇银行',
  '北京农村商业银行',
  '北京顺义银座村镇银行',
  '北京通州中银富登村镇银行股份有限公司',
  '北京延庆村镇银行',
  '北京银行',
  '北京中关村银行',
  '本溪银行',
  '比利时富通银行',
  '比利时联合银行',
  '渤海银行',
  '财务公司',
  '苍梧深通村镇银行',
  '沧州银行',
  '常宁珠江村镇银行股份有限公司',
  '朝兴银行',
  '朝阳银行',
  '潮州潮安长江村镇银行',
  '潮州农村商业银行股份有限公司',
  '成都农商银行',
  '成都青白江融兴村镇银行',
  '成都银行',
  '承德银行',
  '城市商业银行资金清算中心',
  '城市信用合作社',
  '崇州上银村镇银行',
  '稠州村镇银行',
  '慈溪民生村镇银行股份有限公司',
  '达州农村商业银行',
  '达州银行',
  '大华银行',
  '大连保税区珠江村镇银行股份有限公司',
  '大连农村商业银行',
  '大连银行',
  '大同银行',
  '大新银行（中国）有限公司',
  '丹东银行',
  '道亨银行',
  '德国北德意志州银行',
  '德国商业银行',
  '德累斯顿银行',
  '德阳农村商业银行',
  '德意志银行',
  '德州银行',
  '第一商业银行股份有限公司',
  '东方汇理银行',
  '东莞黄江珠江村镇银行股份有限公司',
  '东莞农村商业银行',
  '东莞银行',
  '东亚银行',
  '东营银行',
  '都江堰金都村镇银行',
  '俄罗斯外贸银行公开股份公司',
  '峨眉山中成村镇银行股份有限公司',
  '鄂尔多斯银行',
  '鄂州农村商业银行',
  '恩施农村商业银行',
  '法国巴黎银行',
  '法国里昂信贷银行',
  '法国外贸银行',
  '法国兴业银行',
  '法兰西银行',
  '防城国民村镇银行',
  '丰业银行',
  '佛山农村商业银行股份有限公司',
  '扶绥深通村镇银行',
  '福建福鼎恒兴村镇银行股份有限公司',
  '福建海峡银行',
  '福建华通银行',
  '福建省农村信用社联合社',
  '福建亚洲银行',
  '福建政和泰隆村镇银行有限责任公司',
  '抚顺银行',
  '阜新银行',
  '富滇银行',
  '甘肃农村商业银行',
  '甘肃省农村合作银行',
  '甘肃银行',
  '赣州银行',
  '广安恒丰村镇银行',
  '广安农村商业银行',
  '广安思源农村商业银行',
  '广东海丰农村商业银行股份有限公司',
  '广东河源农村商业银行股份有限公司',
  '广东鹤山农村商业银行股份有限公司',
  '广东华兴银行',
  '广东揭阳农村商业银行股份有限公司',
  '广东开平农村商业银行股份有限公司',
  '广东罗定农村商业银行股份有限公司',
  '广东南海农村商业银行股份有限公司',
  '广东南粤银行',
  '广东清远农村商业银行股份有限公司',
  '广东省农村信用社联合社',
  '广东顺德农村商业银行',
  '广东台山农村商业银行股份有限公司',
  '广东阳江农村商业银行股份有限公司',
  '广东郁南农村商业银行股份有限公司',
  '广东云浮农村商业银行股份有限公司',
  '广发银行股份有限公司',
  '广西北部湾银行',
  '广西北流柳银村镇银行',
  '广西博白柳银村镇银行',
  '广西临桂农村商业银行',
  '广西柳江柳银村镇银行',
  '广西陆川柳银村镇银行',
  '广西融水柳银村镇银行',
  '广西兴业柳银村镇银行',
  '广西壮族自治区农村信用社联合社',
  '广元农村商业银行',
  '广元市包商贵民村镇银行',
  '广元市贵商村镇银行',
  '广州从化柳银村镇银行',
  '广州农村商业银行',
  '广州银行',
  '贵阳农村商业银行股份有限公司',
  '贵阳银行',
  '贵州省农村信用社联合社',
  '贵州银行',
  '桂林国民村镇银行',
  '桂林银行',
  '国民银行（中国）有限公司',
  '国泰世华商业银行股份有限公司',
  '哈尔滨银行',
  '哈密市商业银行',
  '海口联合农村商业银行',
  '海南保亭融兴村镇银行',
  '海南省农村信用社联合社',
  '海南银行',
  '海阳珠江村镇银行股份有限公司',
  '邯郸银行',
  '韩国产业银行',
  '韩国外换银行',
  '韩国中小企业银行',
  '韩亚银行',
  '汉口银行',
  '杭州银行',
  '合作金库商业银行股份有限公司',
  '河北省农村信用社',
  '河北省农村信用社联合社',
  '河北邢州农村商业银行股份有限公司',
  '河北银行',
  '河北正定农村商业银行股份有限公司西平乐支行',
  '荷兰合作银行（中国）有限公司',
  '荷兰商业银行',
  '荷兰万贝银行',
  '荷兰银行',
  '贺州八步东盈村镇银行',
  '鹤山珠江村镇银行股份有限公司',
  '黑龙江省农村信用社',
  '恒丰银行',
  '恒生银行',
  '横县桂商村镇银行',
  '衡水银行',
  '洪湖融兴村镇银行',
  '葫芦岛银行',
  '湖北大冶泰隆村镇银行',
  '湖北荆门掇刀包商村镇银行',
  '湖北三峡农村商业银行',
  '湖北三峡农村商业银行武昌支行',
  '湖北省农村信用社联合社',
  '湖北银行',
  '湖南三湘银行',
  '湖南邵东农村商业银行股份有限公司',
  '湖南省农村信用社联合社',
  '湖州银行',
  '花旗银行',
  '华美银行（中国）有限公司',
  '华南商业银行股份有限公司',
  '华侨银行',
  '华融湘江银行',
  '华商银行',
  '华夏银行',
  '华一银行',
  '黄冈农村商业银行',
  '黄石农村商业银行',
  '辉县珠江村镇银行股份有限公司',
  '徽商银行',
  '惠州农村商业银行股份有限公司',
  '吉林省农村信用社联合社',
  '吉林亿联银行',
  '吉林银行',
  '吉州珠江村镇银行股份有限公司',
  '集友银行',
  '济宁银行',
  '嘉兴银行',
  '犍为中成村镇银行股份有限公司',
  '建东银行',
  '建湖中成村镇银行股份有限公司',
  '江门农村商业银行股份有限公司 ',
  '江苏宝应农村商业银行',
  '江苏滨海农村商业银行',
  '江苏常熟农村商业银行',
  '江苏大丰江南村镇银行股份有限公司',
  '江苏大丰农村商业银行',
  '江苏丹阳保得村镇银行股份有限公司',
  '江苏丹阳农村商业银行',
  '江苏东海农村商业银行',
  '江苏东海张农商村镇银行有限责任公司',
  '江苏东台农村商业银行',
  '江苏丰县民丰村镇银行有限责任公司',
  '江苏丰县农村商业银行',
  '江苏阜宁农村商业银行',
  '江苏赣榆农村商业银行',
  '江苏赣榆通商村镇银行股份有限公司',
  '江苏赣榆通商村镇银行股份有限公司',
  '江苏高淳农村商业银行',
  '江苏高邮农村商业银行',
  '江苏灌南民丰村镇银行有限责任公司',
  '江苏灌南农村商业银行',
  '江苏灌云民丰村镇银行有限责任公司',
  '江苏灌云农村商业银行',
  '江苏海安农村商业银行',
  '江苏海安盐海村镇银行股份有限公司',
  '江苏海门农村商业银行',
  '江苏邗江民泰村镇银行股份有限公司',
  '江苏洪泽农村商业银行',
  '江苏淮安光大村镇银行股份有限公司',
  '江苏淮安农村商业银行',
  '江苏建湖农村商业银行',
  '江苏江都农村商业银行',
  '江苏江南农村商业银行',
  '江苏江阴农村商业银行',
  '江苏姜堰农村商业银行',
  '江苏金湖民泰村镇银行股份有限公司',
  '江苏金湖农村商业银行',
  '江苏靖江农村商业银行',
  '江苏靖江润丰村镇银行股份有限公司',
  '江苏句容农村商业银行',
  '江苏溧水农村商业银行',
  '江苏连云港东方农村商业银行',
  '江苏涟水农村商业银行',
  '江苏涟水太商村镇银行股份有限公司',
  '江苏民丰农村商业银行',
  '江苏南通农村商业银行',
  '江苏南通如皋包商村镇银行股份有限公司营业部',
  '江苏沛县汉源村镇银行股份有限公司',
  '江苏沛县农村商业银行',
  '江苏邳州农村商业银行',
  '江苏启东农村商业银行',
  '江苏如东农村商业银行',
  '江苏如东融兴村镇银行股份有限公司',
  '江苏如皋农村商业银行',
  '江苏射阳农村商业银行',
  '江苏射阳太商村镇银行股份有限公司',
  '江苏省农村信用社联合社',
  '江苏沭阳东吴村镇银行股份有限公司',
  '江苏沭阳农村商业银行',
  '江苏泗洪东吴村镇银行股份有限公司',
  '江苏泗洪农村商业银行',
  '江苏泗阳东吴村镇银行股份有限公司',
  '江苏泗阳农村商业银行',
  '江苏苏商银行股份有限公司',
  '江苏睢宁农村商业银行',
  '江苏泰兴农村商业银行',
  '江苏泰州农村商业银行',
  '江苏通州华商村镇银行股份有限公司',
  '江苏响水农村商业银行',
  '江苏新沂汉源村镇银行股份有限公司',
  '江苏新沂农村商业银行',
  '江苏兴化农村商业银行',
  '江苏宿豫东吴村镇银行股份有限公司',
  '江苏盱眙农村商业银行',
  '江苏盱眙珠江村镇银行股份有限公司',
  '江苏徐州淮海农村商业银行',
  '江苏徐州彭城农村商业银行',
  '江苏徐州铜山农村商业银行',
  '江苏盐城农村商业银行',
  '江苏扬中农村商业银行',
  '江苏扬州农村商业银行',
  '江苏仪征包商村镇银行有限责任公司营业部',
  '江苏仪征农村商业银行',
  '江苏宜兴农村商业银行',
  '江苏银行',
  '江苏长江商业银行',
  '江苏镇江农村商业银行',
  '江苏紫金农村商业银行',
  '江苏紫金农村商业银行镇江分行',
  '江西省农村信用社联合社',
  '江西银行',
  '江西裕民银行',
  '交通银行',
  '交银兴民村镇银行',
  '金华银行',
  '金山惠民村镇银行',
  '金堂汇金村镇银行',
  '锦州银行',
  '晋城银行',
  '晋商银行',
  '晋中银行',
  '经人民银行批准的其他银行',
  '荆门东宝惠民村镇银行',
  '荆门农村商业银行',
  '荆州农村商业银行',
  '九江银行',
  '句容苏南村镇银行股份有限公司',
  '筠连中成村镇银行股份有限公司',
  '库尔勒银行',
  '昆仑银行',
  '昆山鹿城村镇银行股份有限公司',
  '昆山农村商业银行',
  '莱商银行',
  '莱州珠江村镇银行股份有限公司',
  '兰州银行',
  '阆中融兴村镇银行',
  '廊坊银行',
  '乐山三江农村商业银行',
  '乐山市商业银行',
  '连云港东方农村商业银行',
  '涟源沪农商村镇银行',
  '凉山农村商业银行',
  '辽宁省农村信用社联合社',
  '辽沈银行股份有限公司',
  '辽阳银行',
  '廖创兴银行',
  '临商银行',
  '灵川深通村镇银行',
  '灵山泰业村镇银行',
  '柳州银行',
  '龙江银行',
  '泸县元通村镇银行',
  '泸州江阳农村商业银行',
  '泸州龙马潭农村商业银行',
  '泸州农村商业银行',
  '泸州市商业银行',
  '鹿寨渝农商村镇银行',
  '马来亚银行',
  '茂名电白长江村镇银行股份有限公司',
  '茂名市城区农村信用合作联社',
  '眉山农村商业银行',
  '梅州农村商业银行股份有限公司',
  '美国银行',
  '美一银行',
  '蒙特利尔银行',
  '绵阳市商业银行',
  '绵竹浦发村镇银行',
  '民富村镇银行',
  '摩根大通银行',
  '南部县中成村镇银行股份有限公司',
  '南充嘉陵中成村镇银行',
  '南充农村商业银行',
  '南京银行',
  '南宁隆安长江村镇银行',
  '南宁兴宁长江村镇银行股份有限公司',
  '南雄农村商业银行股份有限公司',
  '南洋商业银行',
  '内江农村商业银行',
  '内蒙古银行',
  '内蒙古自治区农村信用社联合社',
  '宁波东海银行',
  '宁波国际银行',
  '宁波通商银行',
  '宁波银行',
  '宁夏黄河农村商业银行',
  '宁夏银行',
  '纽约银行',
  '农村合作银行',
  '农科村镇银行',
  '攀枝花农村商业银行',
  '盘谷银行',
  '盘锦银行',
  '彭山珠江村镇银行股份有限公司',
  '彭州民生村镇银行',
  '平安银行股份有限公司',
  '平果国民村镇银行',
  '葡国储蓄信贷银行',
  '齐鲁银行',
  '齐商银行',
  '其他商业银行',
  '其他商业银行',
  '其他商业银行',
  '启东珠江村镇银行股份有限公司',
  '潜江农村商业银行',
  '秦皇岛银行',
  '青岛国际银行',
  '青岛银行',
  '青海省农村信用社',
  '青海银行',
  '邛崃国民村镇银行',
  '曲靖市商业银行',
  '泉州银行',
  '日本横滨银行股份有限公司',
  '日本三井住友信托银行股份有限公司',
  '日联银行',
  '日照银行',
  '瑞典北欧斯安银行有限公司',
  '瑞典商业银行公共有限公司',
  '瑞典银行有限公司',
  '瑞士信贷第一波士顿银行',
  '瑞士银行(中国)有限公司',
  '瑞穗银行（中国）有限公司',
  '三都富民村镇银行股份有限公司',
  '三井住友银行',
  '三菱东京日联银行（中国）有限公司',
  '三水珠江村镇银行股份有限公司',
  '厦门国际银行',
  '厦门银行',
  '山东省农村信用社联合社',
  '山东沂南蓝海村镇银行股份有限公司',
  '山口银行',
  '山西省农村信用社联合社',
  '陕西临潼海丝村镇银行股份有限公司',
  '陕西秦农农村商业银行',
  '陕西省农村信用社联合社',
  '汕头市潮阳农村信用合作联社',
  '汕尾农村商业银行股份有限公司',
  '上海－巴黎国际银行',
  '上海华瑞银行',
  '上海嘉定洪都村镇银行',
  '上海闵行上银村镇银行股份有限公司',
  '上海农村商业银行',
  '上海浦东发展银行',
  '上海浦东恒通村镇银行',
  '上海浦东江南村镇银行',
  '上海青浦刺桐红村镇银行',
  '上海商业银行有限公司',
  '上海松江富明村镇银行',
  '上海银行',
  '上林国民村镇银行',
  '上饶银行',
  '韶关农村商业银行股份有限公司',
  '韶关市区农村信用合作联社',
  '绍兴银行',
  '深圳福田银座村镇银行',
  '深圳农村商业银行',
  '深圳前海微众银行',
  '什邡思源村镇银行',
  '神农架农村商业银行',
  '盛京银行',
  '十堰农村商业银行',
  '石嘴山银行',
  '始兴大众村镇银行股份有限公司',
  '首都银行及信托公司',
  '双流诚民村镇银行',
  '四川安州农村商业银行',
  '四川苍溪农村商业银行',
  '四川大英农村商业银行',
  '四川大竹农村商业银行',
  '四川大竹渝农商村镇银行',
  '四川峨眉山农村商业银行',
  '四川富顺农村商业银行',
  '四川高县农村商业银行',
  '四川珙县农村商业银行',
  '四川古蔺农村商业银行',
  '四川广汉农村商业银行',
  '四川合江农村商业银行',
  '四川华蓥农村商业银行',
  '四川犍为农村商业银行',
  '四川简阳农村商业银行',
  '四川剑阁农村商业银行',
  '四川江安农村商业银行',
  '四川江油华夏村镇银行',
  '四川筠连农村商业银行',
  '四川阆中农村商业银行',
  '四川乐至农村商业银行',
  '四川邻水农村商业银行',
  '四川隆昌农村商业银行',
  '四川泸县农村商业银行',
  '四川罗江农村商业银行',
  '四川绵竹农村商业银行',
  '四川名山锦城村镇银行',
  '四川南部农村商业银行',
  '四川平武农村商业银行',
  '四川屏山农村商业银行',
  '四川青川农村商业银行',
  '四川青神农村商业银行',
  '四川渠县农村商业银行',
  '四川仁寿农村商业银行',
  '四川三台农村商业银行',
  '四川射洪农村商业银行',
  '四川什邡农村商业银行',
  '四川省农村信用社联合社',
  '四川天府银行',
  '四川万源农村商业银行',
  '四川威远农村商业银行',
  '四川武胜农村商业银行',
  '四川西充农村商业银行',
  '四川新网银行',
  '四川兴文石海农村商业银行',
  '四川叙永农村商业银行',
  '四川宣汉农村商业银行',
  '四川仪陇惠民村镇银行',
  '四川仪陇农村商业银行',
  '四川宜宾金江农村商业银行',
  '四川银行股份有限公司',
  '四川营山农村商业银行',
  '四川长宁竹海农村商业银行',
  '四川梓潼农村商业银行',
  '松滋中银富登村镇银行',
  '嵩明沪农商村镇银行',
  '苏州农村商业银行',
  '苏州吴中珠江村镇银行股份有限公司',
  '苏州银行',
  '睢宁中银富登村镇银行股份有限公司',
  '随州农村商业银行',
  '遂宁安居融兴村镇银行',
  '遂宁农村商业银行',
  '遂宁银行',
  '台湾土地银行',
  '台湾银行股份有限公司',
  '台州银行',
  '太仓民生村镇银行股份有限公司',
  '太仓农村商业银行',
  '泰安银行',
  '泰华农民银行',
  '泰京银行',
  '唐山银行',
  '天津滨海农村商业银行',
  '天津金城银行',
  '天津农村商业银行',
  '天津银行',
  '天门农村商业银行',
  '田阳兴阳村镇银行',
  '铁岭银行',
  '威海市商业银行',
  '潍坊银行',
  '温州民商银行',
  '温州银行',
  '文安县惠民村镇银行股份有限公司',
  '乌海银行',
  '乌鲁木齐银行',
  '无锡滨湖兴福村镇银行股份有限公司',
  '无锡农村商业银行',
  '武汉农村商业银行',
  '武汉众邦银行',
  '武鸣漓江村镇银行',
  '西安银行',
  '西藏堆龙民泰村镇银行股份有限公司',
  '西藏银行',
  '西德意志银行',
  '仙桃农村商业银行',
  '咸宁农村商业银行',
  '香港地区的银行',
  '香港上海汇丰银行',
  '襄阳农村商业银行',
  '孝感农村商业银行',
  '协和银行',
  '新都桂城村镇银行',
  '新韩银行',
  '新疆汇和银行',
  '新疆维吾尔自治区农村信用社联合社',
  '新疆银行',
  '新津珠江村镇银行股份有限公司',
  '新联商业银行',
  '星展银行（中国）有限公司',
  '邢台银行',
  '兴化苏南村镇银行股份有限公司',
  '兴宁珠江村镇银行股份有限公司',
  '兴业银行',
  '雅安农村商业银行',
  '雅安市商业银行',
  '雅安雨城惠民村镇银行',
  '亚洲商业银行',
  '烟台银行',
  '盐城滨海兴福村镇银行股份有限公司',
  '扬中恒丰村镇银行股份有限公司',
  '扬州高邮兴福村镇银行股份有限公司',
  '扬州广陵中成村镇银行股份有限公司',
  '阳泉市商业银行',
  '宜宾翠屏农村商业银行',
  '宜宾南溪农村商业银行',
  '宜宾农村商业银行',
  '宜宾市商业银行',
  '宜宾兴宜村镇银行',
  '宜州深通村镇银行',
  '意大利联合圣保罗银行股份有限公司',
  '意大利裕信银行股份有限公司',
  '银海国民村镇银行',
  '鄞州银行',
  '英国巴克莱银行有限公司',
  '营口沿海银行',
  '营口银行',
  '应城融兴村镇银行',
  '永丰银行（中国）有限公司',
  '永亨银行',
  '永隆银行',
  '友利银行',
  '鱼峰信合村镇银行',
  '榆林榆阳民生村镇银行股份有限公司',
  '玉山商业银行股份有限公司',
  '玉田农商银行',
  '云浮市云城区农村信用合作联社',
  '云浮新兴东盈村镇银行股份有限公司',
  '云南红塔银行',
  '云南省农村信用社联合社',
  '云南巍山农村商业银行',
  '枣庄银行',
  '渣打银行',
  '湛江农村商业银行股份有限公司',
  '张家港农村商业银行',
  '张家口银行',
  '彰化商业银行股份有限公司',
  '长安银行',
  '长城华西银行',
  '长宁中成村镇银行股份有限公司',
  '长沙银行',
  '长顺富民村镇银行股份有限公司',
  '长治银行',
  '招商银行',
  '兆丰国际商业银行股份有限公司',
  '肇庆端州农村商业银行股份有限公司',
  '浙江常山联合村镇银行股份有限公司',
  '浙江稠州商业银行',
  '浙江德清湖商村镇银行股份有限公司',
  '浙江嘉善联合村镇银行股份有限公司',
  '浙江建德湖商村镇银行股份有限公司',
  '浙江江山中银富登村镇银行有限责任公司',
  '浙江缙云联合村镇银行股份有限公司',
  '浙江柯桥联合村镇银行股份有限公司',
  '浙江乐清联合村镇银行股份有限公司',
  '浙江临海湖商村镇银行股份有限公司',
  '浙江龙游义商村镇银行股份有限公司',
  '浙江民泰商业银行',
  '浙江平湖工银村镇银行股份有限公司',
  '浙江衢州衢江上银村镇银行股份有限公司',
  '浙江瑞安湖商村镇银行股份有限公司',
  '浙江商业银行',
  '浙江省农村信用社联合社',
  '浙江泰隆商业银行',
  '浙江天台民生村镇银行股份有限公司',
  '浙江网商银行',
  '浙江温岭联合村镇银行股份有限公司',
  '浙江仙居富民村镇银行股份有限公司',
  '浙江萧山湖商村镇银行股份有限公司',
  '浙江义乌联合村镇银行股份有限公司',
  '浙江云和联合村镇银行股份有限公司',
  '浙江长兴联合村镇银行股份有限公司',
  '浙江诸暨联合村镇银行股份有限公司',
  '浙商银行',
  '郑州银行',
  '郑州珠江村镇银行股份有限公司',
  '中国工商银行',
  '中国光大银行',
  '中国建设银行',
  '中国民生银行',
  '中国农业银行',
  '中国人民银行公开市场操作室',
  '中国银行',
  '中国银行间外汇交易中心',
  '中国邮政储蓄银行',
  '中山东凤珠江村镇银行股份有限公司',
  '中山农村商业银行股份有限公司',
  '中信百信银行',
  '中信银行',
  '中信银行国际（中国）有限公司',
  '中央国债登记结算有限责任公司',
  '中银富登村镇银行',
  '中银香港',
  '中原银行',
  '重庆巴南浦发村镇银行股份有限公司',
  '重庆北碚稠州村镇银行股份有限公司',
  '重庆璧山工银村镇银行有限责任公司',
  '重庆大足汇丰村镇银行有限责任公司',
  '重庆丰都汇丰村镇银行有限责任公司',
  '重庆富民银行',
  '重庆江北恒丰村镇银行股份有限公司',
  '重庆江津石银村镇银行股份有限公司',
  '重庆九龙坡民泰村镇银行股份有限公司',
  '重庆梁平澳新村镇银行有限责任公司',
  '重庆南岸中银富登村镇银行有限公司',
  '重庆南川石银村镇银行股份有限公司',
  '重庆农村商业银行',
  '重庆彭水民泰村镇银行股份有限公司',
  '重庆荣昌汇丰村镇银行有限责任公司',
  '重庆三峡银行',
  '重庆市大渡口融兴村镇银行有限责任公司',
  '重庆市沙坪坝融兴村镇银行有限责任公司',
  '重庆市武隆融兴村镇银行有限责任公司',
  '重庆市酉阳融兴村镇银行有限责任公司',
  '重庆铜梁浦发村镇银行股份有限公司',
  '重庆万州建信村镇银行有限责任公司',
  '重庆秀山北银村镇银行股份有限公司',
  '重庆银行',
  '重庆永川北银村镇银行股份有限公司',
  '重庆渝北银座村镇银行股份有限公司',
  '重庆渝北银座村镇银行有限责任公司',
  '重庆云阳恒丰村镇银行股份有限公司',
  '重庆忠县稠州村镇银行股份有限公司',
  '珠海华润银行',
  '珠海南通银行',
  '珠海农村商业银行股份有限公司',
  '资阳民生村镇银行',
  '资阳农村商业银行',
  '资阳雁江农村合作银行',
  '自贡农村商业银行',
  '自贡银行',
  '自贡中成村镇银行',
  '自贡中成村镇银行股份有限公司沿滩支行',
  ].map((x,i)=>{
    return {
      id:i,
      label:x,
      value:x
    }
  })
export const nationalityList = ['中华人民共和国','中国',
  '中国澳门',
  '中国台湾',
  '中国香港',
  '阿尔巴尼亚',
  '阿尔及利亚',
  '阿富汗',
  '阿根廷',
  '阿联酋',
  '阿鲁巴',
  '阿曼',
  '阿塞拜疆',
  '埃及',
  '埃塞俄比亚',
  '爱尔兰',
  '爱沙尼亚',
  '安道尔',
  '安哥拉',
  '安圭拉',
  '安提瓜和巴布达',
  '奥地利',
  '澳大利亚',
  '巴巴多斯',
  '巴布亚新几内亚',
  '巴哈马',
  '巴基斯坦',
  '巴拉圭',
  '巴勒斯坦',
  '巴林',
  '巴拿马',
  '巴西',
  '白俄罗斯',
  '百慕大',
  '保加利亚',
  '北马里亚纳',
  '贝宁',
  '比利时',
  '冰岛',
  '波多黎各',
  '波黑',
  '波兰',
  '玻利维亚',
  '伯利兹',
  '博茨瓦纳',
  '不丹',
  '布基纳法索',
  '布隆迪',
  '布维岛',
  '朝鲜',
  '赤道几内亚',
  '丹麦',
  '德国',
  '东帝汶',
  '多哥',
  '多米尼加',
  '多米尼克',
  '俄罗斯联邦',
  '厄瓜多尔',
  '厄立特里亚',
  '法国',
  '法罗群岛',
  '法属波利尼西亚',
  '法属圭亚那',
  '法属南部领地',
  '梵蒂冈',
  '菲律宾',
  '斐济',
  '芬兰',
  '佛得角',
  '福克兰群岛（马尔维纳斯）',
  '冈比亚',
  '刚果（布）',
  '刚果（金）',
  '哥伦比亚',
  '哥斯达黎加',
  '格林纳达',
  '格陵兰',
  '格鲁吉亚',
  '根西岛',
  '古巴',
  '瓜德罗普',
  '关岛',
  '圭亚那',
  '哈萨克斯坦',
  '海地',
  '韩国',
  '荷兰',
  '荷属安的列斯',
  '赫德岛和麦克唐纳岛',
  '黑山',
  '洪都拉斯',
  '基里巴斯',
  '吉布提',
  '吉尔吉斯斯坦',
  '几内亚',
  '几内亚比绍',
  '加拿大',
  '加纳',
  '加蓬',
  '柬埔寨',
  '捷克',
  '津巴布韦',
  '喀麦隆',
  '卡塔尔',
  '开曼群岛',
  '科科斯（基林）群岛',
  '科摩罗',
  '科特迪瓦',
  '科威特',
  '克罗地亚',
  '肯尼亚',
  '库克群岛',
  '拉脱维亚',
  '莱索托',
  '老挝',
  '黎巴嫩',
  '立陶宛',
  '利比里亚',
  '利比亚',
  '列支敦士登',
  '留尼汪',
  '卢森堡',
  '卢旺达',
  '罗马尼亚',
  '马达加斯加',
  '马尔代夫',
  '马耳他',
  '马拉维',
  '马来西亚',
  '马里',
  '马绍尔群岛',
  '马提尼克',
  '马约特',
  '毛里求斯',
  '毛里塔尼亚',
  '美国',
  '美国本土外小岛屿',
  '美属萨摩亚',
  '美属维尔京群岛',
  '蒙古',
  '蒙特塞拉特',
  '孟加拉国',
  '秘鲁',
  '密克罗尼西亚联邦',
  '缅甸',
  '摩尔多瓦',
  '摩洛哥',
  '摩纳哥',
  '莫桑比克',
  '墨西哥',
  '纳米比亚',
  '南非',
  '南极洲',
  '南乔治亚岛和南桑德韦奇岛',
  '南斯拉夫',
  '南苏丹',
  '瑙鲁',
  '尼泊尔',
  '尼加拉瓜',
  '尼日尔',
  '尼日利亚',
  '纽埃',
  '挪威',
  '诺福克岛',
  '帕劳',
  '皮特凯恩',
  '葡萄牙',
  '前南马其顿',
  '日本',
  '瑞典',
  '瑞士',
  '萨尔瓦多',
  '萨摩亚',
  '塞尔维亚',
  '塞拉利昂',
  '塞内加尔',
  '塞浦路斯',
  '塞舌尔',
  '沙特阿拉伯',
  '圣诞岛',
  '圣多美和普林西比',
  '圣赫勒拿',
  '圣基茨和尼维斯',
  '圣卢西亚',
  '圣马力诺',
  '圣皮埃尔和密克隆',
  '圣文森特和格林纳丁斯',
  '斯里兰卡',
  '斯洛伐克',
  '斯洛文尼亚',
  '斯瓦尔巴岛和扬马延岛',
  '斯威士兰',
  '苏丹',
  '苏里南',
  '所罗门群岛',
  '索马里',
  '塔吉克斯坦',
  '泰国',
  '坦桑尼亚',
  '汤加',
  '特克斯和凯科斯群岛',
  '特立尼达和多巴哥',
  '突尼斯',
  '图瓦卢',
  '土耳其',
  '土库曼斯坦',
  '托克劳',
  '瓦利斯和富图纳',
  '瓦努阿图',
  '危地马',
  '委内瑞拉',
  '文莱',
  '乌干达',
  '乌克兰',
  '乌拉圭',
  '乌兹别克斯坦',
  '西班牙',
  '西撒哈拉',
  '希腊',
  '新加坡',
  '新喀里多尼亚',
  '新西兰',
  '匈牙利',
  '叙利亚',
  '牙买加',
  '亚美尼亚',
  '也门',
  '伊拉克',
  '伊朗',
  '以色列',
  '意大利',
  '印度',
  '印度尼西亚',
  '英国',
  '英属维尔京群岛',
  '英属印度洋领地',
  '约旦',
  '越南',
  '赞比亚',
  '乍得',
  '直布罗陀',
  '智利',
  '中非',
  ].map((x,i)=>{
    return {
      id:i,
      label:x,
      value:x
    }
  })
export const hireType = [
  {
    label: "雇员",
    value: 0
  },
  {
    label: "保险营销员",
    value: 1
  },
  {
    label: "证券经纪人",
    value: 2
  },
  {
    label: "实习学生（全日制学历教育）",
    value: 3
  },
  {
    label: "其他",
    value: 4
  },
]
export const currentJobInfo = [
  {
    label: "当年首次入职学生",
    value: "1"
  },
  {
    label: "当年首次入职其他人员",
    value: "2"
  },
]
export const cardType = [
  {
    label: "身份证",
    value: "1"
  },
  {
    label: "港澳居民来往内地通行证",
    value: "2"
  },
  {
    label: "中华人民共和国港澳居民居住证",
    value: "3"
  },{
    label: "台湾居民来往大陆通行证",
    value: "4"
  },{
    label: "中华人民共和国台湾居民居住证",
    value: "5"
  },{
    label: "中国护照",
    value: "6"
  },{
    label: "外国护照",
    value: "7"
  },{
    label: "外国人永久居留身份证（外国人永久居留证）",
    value: "8"
  },{
    label: "中华人民共和国外国人工作许可证（A类）",
    value: "9"
  },{
    label: "中华人民共和国外国人工作许可证（B类）",
    value: "10"
  }
  ,{
    label: "中华人民共和国外国人工作许可证（C类）",
    value: "11"
  },{
    label: "其他个人证件",
    value: "12"
  },
]
export const formRenderList =  [
  {
    title: "",
    children: [
      {
        label: "人员状态",
        type: "radio",
        prop: "status",
        options: [
          {
            label: "在职",
            disabled: false,
            value: 1
          },
          {
            label: "离职",
            disabled: false,
            value: 2
          }
        ]
      }
    ]
  },
  {
    title: "基本信息",
    children: [
      {
        isRow: true,
        children: [
          {
            label: "证件类型",
            type: "select",
            prop: "cardType",
            disabled: false,
            options: cardType
          },{
            label: "证件号码",
            type: "input",
            disabled: false,
            prop: "cardNo",
          }
        ]
      },
      {
        isRow: true,
        children: [
          {
            label: "姓名",
            type: "input",
            disabled: false,
            prop: "name",
          },{
            label: "国籍（地区）",
            type: "select",
            disabled: false,
            prop: "nationality",
            options:nationalityList,
            // options: [
            //   {
            //     label: "中国",
            //     value: "1"
            //   },
            //   {
            //     label: "其他",
            //     value: "2"
            //   }
            // ]
          }
        ]
      },
      {
        isRow: true,
        children: [
          {
            label: "性别",
            type: "select",
            disabled: false,
            prop: "gender",
            options: [
              {
                label: "男",
                value: 1
              },
              {
                label: "女",
                value: 2
              }
            ]
          },{
            label: "学历",
            type: "select",
            disabled: false,
            prop: "education",
            options: [
              {
                label: "初中",
                value: "1"
              },
              {
                label: "高中",
                value: "2"
              },
              {
                label: "中专",
                value: "3"
              },
              {
                label: "大专",
                value: "4"
              },{
                label: "本科",
                value: "5"
              },
              {
                label: "硕士",
                value: "6"
              },{
                label: "博士",
                value: "7"
              },
              {
                label: "其他",
                value: "8"
              }
            ]
          }
        ]
      },
      {
        isRow: true,
        children: [
          {
            label: "出生日期",
            type: "date",
            disabled: false,
            prop: "birthday",
          },{
            label: "纳税人识别号",
            type: "input",
            disabled: true,
            prop: "identifyNo",
          }
        ]
      },
      {
        isRow: true,
        isTail: true,
        children: [
          {
            label: "是否存在以下情形",
            type: "checkbox",
            disabled: false,
            prop: "situation",
            options: [
              {
                label: "残疾",
                value: "1"
              },
              {
                label: "烈属",
                value: "2"
              },
              {
                label: "孤老",
                value: "3"
              }
            ]
          }
        ]
      },
      {
        isRow: true,
        children: [
          {
            label: "残疾证件类型",
            type: "select",
            disabled: false,
            prop: "disabilityType",
            options: [
              {
                label: "视力残疾",
                value: 0
              },
              {
                label: "听力残疾",
                value: 1
              },
              {
                label: "言语残疾",
                value: 2
              },
              {
                label: "肢体残疾",
                value: 3
              },
              {
                label: "智力残疾",
                value: 4
              },
              {
                label: "精神残疾",
                value: 5
              }, {
                label: "多重残疾",
                value: 6
              },
            ]
          },{
            label: "残疾证号",
            type: "input",
            disabled: false,
            prop: "disabilityNo",
          }
        ]
      },
      {
        isRow:true,
        children:[
          {
            label: "烈属证号",
            type: "input",
            disabled: false,
            prop: "heroNo",
          },
          {
            label: "备注",
            type: "input",
            disabled: false,
            prop: "newRemark",
          },
        ]
      }

    ]
  },
  {
    title: "任职受雇从业信息",
    children:[
      {
        isRow: true,
        children: [
          {
            label: "任职受雇从业类型",
            type: "select",
            disabled: false,
            prop: "hireType",
            options: hireType
          }
        ]
      },
      {
        isRow: true,
        children: [
          {
            label: "任职受雇从业日期",
            type: "date",
            disabled: false,
            prop: "entryDate",
          },
          {
            label: "离职日期",
            type: "date",
            disabled: false,
            prop: "dimissionDate",
          }
        ]
      },
      {
        isRow: true,
        children: [
          {
            label: "是否扣除减除费用",
            type: "select",
            disabled: false,
            prop: "payfiveOne",
            options: [
              {
                label: "是",
                value: true
              },
              {
                label: "否",
                value: false
              },
            ]
          },
          {
            label: "入职年度就业情形",
            type: "select",
            prop: "currentJobInfo",
            options: currentJobInfo
          }
        ]
      },
      {
        isRow: true,
        isTail: true,
        children: [
          {
            label: "工号",
            type: "input",
            disabled: false,
            prop: "workCode",
          },
          {
            label: "职位",
            type: "select",
            disabled: false,
            prop: "jobTitle",
            options: [
              {
                label: "高层",
                value: "高层"
              },
              {
                label: "普通",
                value: "普通"
              },
            ]
          }
        ]
      },
    ]
  },
  {
    title: "联系方式",
    children:[
      {
          isRow: true,
          children: [
            {
              label: "手机号",
              type: "input",
              disabled: false,
              prop: "phone",
            },
            {
              label: "电子邮箱",
              type: "input",
              disabled: false,
              prop: "email",
            }
          ]
        },
        {
          isRow: true,
          children: [
            {
              label: "经常居住地址",
              type: "cascader",
              disabled: false,
              prop: "address",
              // options: provinceList,
            },
            {
              label: "具体地址",
              type: "input",
              disabled: false,
              prop: "address_input",
            }
          ]
        },
        {
          isRow: true,
          children: [
            {
              label: "联系地址",
              type: "cascader",
              disabled: false,
              prop: "contactAddress",
            },
            {
              label: "具体地址",
              type: "input",
              disabled: false,
              prop: "contactAddress_input",
            }
          ]
        },
        {
          isRow: true,
          children: [
            {
              label: "开户银行",
              type: "select",
              disabled: false,
              prop: "bankName",
              options:bankList
            },
          ]
        },
        {
          isRow: true,
          children: [
            {
              label: "开户行省份",
              type: "input",
              disabled: false,
              prop: "bankProvince",
            },
            {
              label: "银行账号",
              type: "input",
              disabled: false,
              prop: "bankAccount",
            }
          ]
        },
        {
          isRow: true,
          isTail: true,
          children: [
            {
              label: "户籍所在地",
              type: "cascader",
              disabled: false,
              prop: "homeAddress",
            },
            {
              label: "具体地址",
              type: "input",
              disabled: false,
              prop: "homeAddress_input",
            }
          ]
        },
    ]
  },
  {
    title: "投资信息",
    children:[
    {
          isRow: true,
          isTail: true,
          children: [
            {
              label: "个人投资额",
              type: "input",
              disabled: false,
              prop: "invest",
            },
            {
              label: "个人投资比例",
              type: "input",
              disabled: false,
              prop: "investPer",
            }
          ]
        }
    ]
  }
]





// WEBPACK FOOTER //
// ./src/pages/salary/index.js